/**
 * Created by root on 7/2/19.
 */
/**
 * Created by root on 7/1/19.
 */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import ImportContainer from './components/import.kr.feed.component.js';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const loadDataMgmt = function () {
  ReactDOM.render(
    <Suspense fallback="loading...">
      <I18nextProvider i18n={i18n}>
        <ImportContainer />
      </I18nextProvider>
    </Suspense>,
    document.getElementById('data-management')
  );
};
window.loadDataMgmt = loadDataMgmt;
